import React from 'react';
import PropTypes from 'prop-types';
import { MemoryAnswersV1 } from '../MemoryAnswersV1';
import { BLOCKS, FQ } from '../../shared/memory-map-data';
import { getChosenChapter, getMemoryMap } from '../../shared/memory-map-helpers';
import { useAutoSubmitAnswer } from '../../shared/use-auto-submit-answer';
import styles from './FirstQuestionSlide.css';

const ANSWERS = ['I can answer that', 'I have a lot to say', 'I’d need a minute'].map((text, index) => ({ id: index + 1, text }));

function FirstQuestionSlide({ id, results, submitAnswer, submitTemporaryAnswer, userResponse = {}, delay }) {
    const map = getMemoryMap(results.userResponses);
    const chapterIndex = getChosenChapter(results.userResponses, map);
    const chapter = map.ch[chapterIndex];
    const question = FQ[BLOCKS[chapterIndex].key];
    const { selectAnswer } = useAutoSubmitAnswer({ id, question, userResponse, submitAnswer, submitTemporaryAnswer, delay });
    let said = '';

    if (chapter.heavy) {
        said = `You said: “${chapter.heavy}”. Let’s start gently.`;
    } else if (chapter.warm) {
        said = `You said: “${chapter.warm}”. Let’s start there.`;
    }

    return (
        <section className={styles.form}>
            {Boolean(said) && <p className={styles.said}>{said}</p>}
            <div className={styles.bubble}>
                <h1 className={styles.question}>{question}</h1>
            </div>
            <MemoryAnswersV1
                answers={ANSWERS}
                selectedId={userResponse?.id}
                onSelect={selectAnswer}
                isWhite
            />
        </section>
    );
}

FirstQuestionSlide.propTypes = {
    id: PropTypes.number.isRequired,
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired,
    submitAnswer: PropTypes.func.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    delay: PropTypes.number
};

export {
    FirstQuestionSlide
};
